/**
 * Guest-facing display helpers for UnifiedBooking (manual + public embed use manualBookingDetails).
 */

/**
 * @param {object|null|undefined} booking
 * @returns {string}
 */
export function getManualOrPublicEmbedGuestName(booking) {
  if (!booking?.manualBookingDetails?.clientName) return '';
  const name = String(booking.manualBookingDetails.clientName).trim();
  if (!name) return '';
  if (booking.isPublicEmbedBooking || booking.isManualBooking) return name;
  return '';
}

/**
 * @param {object|null|undefined} booking
 * @returns {string}
 */
export function getBookingGuestDisplayName(booking) {
  const manualName = getManualOrPublicEmbedGuestName(booking);
  if (manualName) return manualName;

  const c = booking?.client;
  if (!c) return '';

  const first = (c.firstName || '').trim();
  const last = (c.lastName || '').trim();
  const full = `${first} ${last}`.trim();
  const lowerFull = full.toLowerCase();
  const looksPlaceholder =
    booking?.isPublicEmbedBooking ||
    lowerFull === 'public embed guest' ||
    (first.toLowerCase() === 'public' && last.toLowerCase() === 'embed guest');

  if (looksPlaceholder) {
    const fallback = (booking.manualBookingDetails?.clientName || '').trim();
    return fallback || 'Guest';
  }

  return full || (c.email || '').trim() || '';
}

/**
 * @param {object|null|undefined} booking
 * @returns {string}
 */
export function getBookingGuestEmailLine(booking) {
  if (!booking) return '';
  if (
    (booking.isManualBooking || booking.isPublicEmbedBooking) &&
    booking.manualBookingDetails?.clientEmail
  ) {
    return String(booking.manualBookingDetails.clientEmail).trim();
  }
  return (booking.client?.email || '').trim();
}
